/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "../../AdminScreens/AdminDSR/AdminDSR.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import axios from "axios";
import {
  Apiurl,
  GetToken,
  RemoveUserSession,
  downloadFile,
  downloadMultipleFiles,
} from "../../../Utils/utils";
import { Modal } from "react-bootstrap";
import { AiOutlineEye, AiOutlineDownload } from "react-icons/ai";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const EmployeeDSR = () => {
  const LoginToken = GetToken();
  const navigate = useNavigate();

  const [showSidebar, setShowSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectFilter, setSelectFilter] = useState("name");

  const [projects, setProjects] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);

  const [showNotesModal, setShowNotesModal] = useState(false);
  const [notesUrl, setNotesUrl] = useState("");

  const [showDocsModal, setShowDocsModal] = useState(false);
  const [docsList, setDocsList] = useState([]);

  const FILE_PREFIX = "https://attendanceapi.elitewebdemo.com";

  const hasValidNotes = (notes) => {
    return typeof notes === "string" && notes.trim() !== "";
  };

  const getDocPath = (doc) => {
    if (!doc || typeof doc !== "object") return "";
    return doc.ProjectDoument || doc.File || doc.projectDoument || doc.file || "";
  };

  const getValidDocs = (docs) => {
    if (!Array.isArray(docs)) return [];

    return docs.filter((doc) => {
      const path = getDocPath(doc);
      return typeof path === "string" && path.trim() !== "";
    });
  };

  const handleViewNotes = (notesFileUrl) => {
    const validNotes = hasValidNotes(notesFileUrl) ? notesFileUrl : "";

    setNotesUrl(
      validNotes
        ? validNotes.startsWith("http")
          ? validNotes
          : FILE_PREFIX + validNotes
        : ""
    );

    setShowNotesModal(true);
  };

  const handleDownloadNotes = (notesFileUrl) => {
    if (!hasValidNotes(notesFileUrl)) return;

    const fullUrl = notesFileUrl.startsWith("http")
      ? notesFileUrl
      : FILE_PREFIX + notesFileUrl;

    const fileName = fullUrl.split("/").pop();
    downloadFile(fullUrl, fileName);
  };

  const handleViewDocs = (docs) => {
    const validDocs = getValidDocs(docs);

    if (validDocs.length === 0) {
      toast.error("No documents available");
      return;
    }

    const formattedDocs = validDocs.map((doc) => {
      const docPath = getDocPath(doc);
      const fullUrl = docPath.startsWith("http")
        ? docPath
        : FILE_PREFIX + docPath;

      return {
        url: fullUrl,
        fileName: docPath.split("\\").pop().split("/").pop(),
      };
    });

    setDocsList(formattedDocs);
    setShowDocsModal(true);
  };

  const handleDownloadAllDocuments = (docsArr) => {
    const validDocs = getValidDocs(docsArr);

    if (validDocs.length === 0) {
      toast.error("No documents available");
      return;
    }

    const files = validDocs.map((doc) => {
      const docPath = getDocPath(doc);
      const fullUrl = docPath.startsWith("http")
        ? docPath
        : FILE_PREFIX + docPath;

      return {
        url: fullUrl,
        fileName: docPath.split("\\").pop().split("/").pop(),
      };
    });

    downloadMultipleFiles(files);
  };

  const handlePreviewSingleDoc = (url) => {
    if (!url) return;
    window.open(url, "_blank");
  };

  const handleDownloadSingleDoc = (url, fileName) => {
    if (!url) return;
    downloadFile(url, fileName);
  };

  const fetchProjectsForEmployee = () => {
    setLoadingProjects(true);

    axios({
      method: "GET",
      url: `${Apiurl()}/Projects/GetProjectTaskForUser`,
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
    })
      .then((response) => {
        if (response?.data?.success) {
          const parsed = JSON.parse(response?.data?.data || "{}");
          const projectsArray = parsed?.Data || [];

          const formattedProjects = projectsArray.map((item) => ({
            id: item.ProjectId,
            name: item.ProjectName || "",
            type: item.ProjectType || "",
            projectNotesFile: item.Notes || "",
            projectDocuments: Array.isArray(item.Documents)
              ? item.Documents
              : [],
          }));

          setProjects(formattedProjects);
        } else {
          setProjects([]);
        }

        setLoadingProjects(false);
      })
      .catch((error) => {
        setLoadingProjects(false);

        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        } else {
          toast.error("Failed to fetch projects");
        }
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);

      return () => clearTimeout(timeoutId);
    }

    setShowSidebar(true);
  }, []);

  useEffect(() => {
    fetchProjectsForEmployee();
  }, []);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredData([]);
      return;
    }

    const filtered = projects.filter((item) => {
      let value = "";

      if (selectFilter === "name") {
        value = item.name;
      } else if (selectFilter === "type") {
        value = item.type;
      }

      return value?.toLowerCase().includes(searchTerm.toLowerCase());
    });

    setFilteredData(filtered);
  }, [searchTerm, selectFilter, projects]);

  const displayData = searchTerm ? filteredData : projects;

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-AdminDSR"
              : "main-container-of-all-employees-page-new-AdminDSR"
          }
        >
          <div className="inner-container-of-all-employees-page">
            <div className="header-of-employees-page">
              <div className="all-employee-AdminDSR">
                <h4>Employee DSR</h4>
              </div>

              <div className="all-employees-AdminDSR">
                <div className="home-icon-AdminDSR">
                  <BiHomeAlt className="home-icon-header-AdminDSR" />
                </div>

                <div className="arrow-icon-AdminDSR">
                  <MdKeyboardArrowRight />
                </div>

                <div className="employee-text-AdminDSR">
                  <p>Project Details</p>
                </div>
              </div>
            </div>
          </div>

          <div className="tabs-section-AdminDSR">
            <button className="tab-button active">Home</button>
          </div>

          <div className="body-part-outer-AdminDSR">
            <div className="inner-body-container-of-employee-AdminDSR row-12">
              <div className="first-side-in-body-AdminDSR">
                <select
                  value={selectFilter}
                  onChange={(e) => setSelectFilter(e.target.value)}
                  className="select-dropdown-AdminDSR"
                >
                  <option value="name">Name</option>
                  <option value="type">Project Type</option>
                </select>

                <div className="input-for-search-in-employee-AdminDSR">
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="table-in-all-emplyee-AdminDSR">
              <table className="table-main-AdminDSR">
                <thead className="thead-main-AdminDSR">
                  <tr>
                    <th>Name</th>
                    <th>Project Type</th>
                    <th>Project Notes</th>
                    <th>Project Documents</th>
                  </tr>
                </thead>

                <tbody className="tbody-main-AdminDSR">
                  {loadingProjects ? (
                    <tr>
                      <td colSpan="4">Loading...</td>
                    </tr>
                  ) : displayData.length > 0 ? (
                    displayData.map((item) => {
                      const notesFileUrl = item.projectNotesFile;
                      const docsArr = item.projectDocuments;
                      const validDocs = getValidDocs(docsArr);

                      return (
                        <tr key={item.id}>
                          <td>{item.name}</td>
                          <td>{item.type}</td>

                          <td>
                            {hasValidNotes(notesFileUrl) ? (
                              <>
                                <button
                                  className="icon-btn-AdminDSR"
                                  title="View Notes"
                                  style={{ marginRight: 4 }}
                                  onClick={() => handleViewNotes(notesFileUrl)}
                                >
                                  <AiOutlineEye />
                                </button>

                                <button
                                  className="icon-btn-AdminDSR"
                                  title="Download Notes"
                                  onClick={() =>
                                    handleDownloadNotes(notesFileUrl)
                                  }
                                >
                                  <AiOutlineDownload />
                                </button>
                              </>
                            ) : (
                              "-"
                            )}
                          </td>

                          <td>
                            {validDocs.length > 0 ? (
                              <>
                                <button
                                  className="icon-btn-AdminDSR"
                                  title="View Documents"
                                  style={{ marginRight: 4 }}
                                  onClick={() => handleViewDocs(validDocs)}
                                >
                                  <AiOutlineEye />
                                </button>

                                <button
                                  className="icon-btn-AdminDSR"
                                  title="Download All Documents"
                                  onClick={() =>
                                    handleDownloadAllDocuments(validDocs)
                                  }
                                >
                                  <AiOutlineDownload />
                                </button>
                              </>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="4">No record found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showNotesModal}
        onHide={() => setShowNotesModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Project Notes</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ height: "80vh" }}>
          {notesUrl ? (
            <iframe
              src={notesUrl}
              title="Project Notes"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          ) : (
            <div>No notes available.</div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showDocsModal}
        onHide={() => setShowDocsModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Project Documents</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {docsList.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th style={{ width: "120px" }}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {docsList.map((doc, index) => (
                  <tr key={index}>
                    <td>{doc.fileName}</td>
                    <td>
                      <button
                        className="icon-btn-AdminDSR"
                        title="Preview"
                        style={{ marginRight: 8 }}
                        onClick={() => handlePreviewSingleDoc(doc.url)}
                      >
                        <AiOutlineEye />
                      </button>

                      <button
                        className="icon-btn-AdminDSR"
                        title="Download"
                        onClick={() =>
                          handleDownloadSingleDoc(doc.url, doc.fileName)
                        }
                      >
                        <AiOutlineDownload />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>No documents available</div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EmployeeDSR;